import { useCallback } from 'react';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { Feedback } from '@helpers';
import { unlogin } from '@reducers/utils';

export const useManageDeactivated = () => {
  const dispatch = useAppDispatch();

  const onContactUs = useCallback(() => {
    Feedback({ type: 'help' });
  }, []);

  const onLogOut = useCallback(() => {
    dispatch(unlogin());
  }, [dispatch]);

  return { onContactUs, onLogOut };
};
